module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("E")]), _vm._v("very possible effort has been made to reproduce the highest quality of images in this volume. The reader should, however, bear in mind that the vast majority of the photographs seen in this book were taken on small compact ‘Brownie’-style cameras, and were usually printed no larger than 2×2 inches. Many were taken hastily and in extremes of lighting – either in harsh sunlight or in the dark confines of the jungle – so there will be a certain amount of variance in brightness and contrast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every possible effort has also been made to check and to confirm the names of those captured on the following pages, and the places where the original photographs were taken. The vast majority of the information has been supplied by the veterans themselves, but with the passing of time, mistakes of memory do occur and the author would be pleased to receive any corrections should a reader spot an error.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout this book, you will see the term ‘bandits’ being used. This term was used by both the Japanese and Chiang Kai-shek during the war to describe ‘communists’. In an effort to distance themselves from this in the eyes of the Malayan Chinese communities, the British changed their official phraseology to ‘communist terrorist’ or ‘CT’ for short. However, every veteran I spoke with always referred to them as ‘bandits’ and so this term has been used in the text that follows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Readers should also be aware of the graphic nature of some of the images, particularly those of dead terrorists. A minimal number of such images have been included here for context in the overall story of the campaign.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ae79b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Author.vue
// module id = 75
// module chunks = 0